export const getYear = (date: number) => {
  return new Date(date).getFullYear()
}

const pad = (num) => (num > 9 ? num : '0' + num)

export const convertSecsToTime = (seconds: number) => {
  const hrs = Math.floor(seconds / 3600)
  const mins = Math.floor((seconds % 3600) / 60)
  const secs = Math.floor(seconds % 60)

  if (hrs > 0) {
    return `${hrs}:${pad(mins)}:${pad(secs)}`
  } else {
    return `${pad(mins)}:${pad(secs)}`
  }
}

export const formatDate = (dateStr: string) => {
  if (!dateStr) return null

  const date = new Date(dateStr)

  const year = date.getFullYear()
  const month = date.toLocaleString('default', { month: 'long' })
  const day = date.getDate()

  return `${month} ${day}, ${year}`
}
